import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../mock';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeader } from './Services';

const Blog = () => {
  const posts = blogPosts.slice(0, 2);
  return (
    <section id="blog" className="relative py-20 md:py-28">
      <div className="squiggle-bg" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <SectionHeader
          eyebrow="From the Blog"
          title={<>Insights that fuel your <em className="italic">EA journey</em></>}
          description="Study strategies, career guides, and industry updates — designed to help you crack the SEE and grow in US taxation."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {posts.map((post) => (
            <Link to={`/blog/${post.slug}`} key={post.id} className="card-soft rounded-2xl p-4 md:p-5 group cursor-pointer hover:shadow-md transition-shadow duration-300 block">
              <div className="aspect-[4/3] rounded-xl overflow-hidden mb-5">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="px-2 pb-3">
                <div className="flex items-center gap-3 mb-3 text-xs text-[#3d3d3d] font-body">
                  <span className="px-2.5 py-1 rounded-full border border-[#143324]/15 text-[#143324]">{post.tag}</span>
                  <span>{post.date}</span>
                </div>
                <h3 className="font-serif-display text-[#143324] text-2xl md:text-3xl leading-tight mb-3">
                  {post.title}
                </h3>
                <p className="text-[#3d3d3d] text-[14px] leading-relaxed font-body mb-5">{post.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-[13px] text-[#143324] font-body group-hover:gap-2.5 transition-all duration-300">
                  Read More <ArrowUpRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center gap-3 flex-wrap">
          <Link to="/contact" className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-body">
            Contact Us <ArrowUpRight size={16} />
          </Link>
          <Link to="/blog" className="inline-flex items-center gap-2 btn-outline px-6 py-3 rounded-full text-sm font-body">
            See All Posts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
